module.exports = __webpack_public_path__ + "static/media/ken.f07d66e0.png";